import { Templates } from '@hellohair/types';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NextQuestionSelect, StepField } from '../_shared/fields';
import { StepDialog, StepEditorProps } from '../_shared/StepDialog';
import { useStepDraft } from '../_shared/useStepDraft';

const Intro: FC<StepEditorProps> = ({ survey, index, onClose }) => {
  const { t } = useTranslation();
  const { draft, set, save, dirty } = useStepDraft<Templates.StepDataIntro>(survey, index);

  return (
    <StepDialog
      survey={survey}
      index={index}
      onSave={save}
      onClose={onClose}
      dirty={dirty}
      edit={
        <StepField
          label={t('editor.field.message')}
          value={draft.question}
          onChange={(value) => set('question', value)}
          multiline
        />
      }
      logic={
        <>
          <NextQuestionSelect
            steps={survey.steps}
            value={draft.followerId}
            onChange={(followerId) => set('followerId', followerId)}
          />
          <StepField
            label={t('editor.field.exitLink')}
            value={draft.exitLink}
            onChange={(value) => set('exitLink', value)}
          />
        </>
      }
      settings={
        <>
          <StepField
            label={t('editor.field.buttonLabel')}
            value={draft.next}
            onChange={(value) => set('next', value)}
          />
          <StepField label={t('editor.field.exitLabel')} value={draft.exit} onChange={(value) => set('exit', value)} />
        </>
      }
    />
  );
};

export default Intro;
